import { render, staticRenderFns } from "./addXianzhi.vue?vue&type=template&id=0de71e01"
import script from "./addXianzhi.vue?vue&type=script&lang=js"
export * from "./addXianzhi.vue?vue&type=script&lang=js"
import style0 from "./addXianzhi.vue?vue&type=style&index=0&id=0de71e01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports